<template>
  <div class="AppIsDown">
    <div v-html="t('app-is-down')"/>
  </div>
</template>

<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'

export default {
  name: 'AppIsDown',
  setup () {
    const { $label: t } = useI36n()

    return { t }
  },
}
</script>

<style scoped>
  .AppIsDown {
    padding: 25px;
  }
</style>